import { z, ZodTypeAny } from 'zod';

const options = [
    { value: 'floor', label: 'Floor mounting' },
    { value: 'wall', label: 'Wall mounting' },
    { value: 'panel', label: 'Panel mounting' },
    { value: 'din-rail', label: 'DIN rail mounting' },
    { value: 'rack', label: 'Rack mounting' },
];

const MountingType: {
    validator: ZodTypeAny;
    options: {
        value: string;
        label: string;
    }[];
} = {
    // @ts-ignore
    validator: z.array(z.enum(options.map((option) => option.value))),
    options,
};

export { MountingType };
